/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeploymentDto } from './DeploymentDto';
import {
    DeploymentDtoFromJSON,
    DeploymentDtoFromJSONTyped,
    DeploymentDtoToJSON,
} from './DeploymentDto';

/**
 * 
 * @export
 * @interface DeploymentsDto
 */
export interface DeploymentsDto {
    /**
     * The deployments.
     * @type {Array<DeploymentDto>}
     * @memberof DeploymentsDto
     */
    items: Array<DeploymentDto>;
    /**
     * The total number of deployments.
     * @type {number}
     * @memberof DeploymentsDto
     */
    total: number;
}

/**
 * Check if a given object implements the DeploymentsDto interface.
 */
export function instanceOfDeploymentsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function DeploymentsDtoFromJSON(json: any): DeploymentsDto {
    return DeploymentsDtoFromJSONTyped(json, false);
}

export function DeploymentsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(DeploymentDtoFromJSON)),
        'total': json['total'],
    };
}

export function DeploymentsDtoToJSON(value?: DeploymentsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(DeploymentDtoToJSON)),
        'total': value.total,
    };
}

